import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField } from "../FormField";
import { ResidentFormData } from "../../schemas/residentForm";

interface DependencyFormProps {
  disabled?: boolean;
  isPpe?: boolean;
}

export const DependencyForm: React.FC<DependencyFormProps> = ({
  disabled = false,
  isPpe = false,
}) => {
  const { t } = useTranslation();
  const { register } = useFormContext<ResidentFormData>();

  return (
    <>
      <p className="font-bold text-off-black text-base sm:text-lg md:text-[20px]">
        {t("form.outbuilding.title")}
      </p>
      <div className="flex flex-col sm:flex-row gap-4 sm:gap-[16px]">
        <FormField label={t("form.outbuilding.cellar")} className="flex-1">
          <input
            type="text"
            {...register("cave")}
            placeholder={t("form.placeholders.cellar")}
            disabled={disabled}
            className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
          />
        </FormField>
        <FormField
          label={isPpe ? t("form.outbuilding.parkingPpe") : t("form.outbuilding.parking")}
          className="flex-1"
        >
          <input
            type="text"
            {...register("parking")}
            placeholder={t("form.placeholders.parking")}
            disabled={disabled}
            className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
          />
        </FormField>
      </div>
      <div className="flex gap-4 sm:gap-[16px]">
        {isPpe ? (
          <FormField
            label={t("form.outbuilding.other")}
            className="flex-1 sm:flex-none sm:w-[280px] md:w-[580px]"
          >
            <input
              type="text"
              {...register("autre")}
              placeholder={t("form.placeholders.other")}
              disabled={disabled}
              className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
            />
          </FormField>
        ) : (
          <FormField
            label={t("form.outbuilding.attic")}
            className="flex-1 sm:flex-none sm:w-[280px] md:w-[580px]"
          >
            <input
              type="text"
              {...register("grenier")}
              placeholder={t("form.placeholders.attic")}
              disabled={disabled}
              className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
            />
          </FormField>
        )}
      </div>
    </>
  );
};
